import React, { useState, useRef, useEffect } from "react";
import { Camera } from "react-camera-pro";
import {
  BrowserRouter as Router,
  Switch,
  useLocation,
  useHistory,
  useParams 
} from "react-router-dom";
import axios from "axios";
import { connect, useSelector } from "react-redux";
import { updatedata,add_newdata } from "../Redux/reduxflow/action";
import baseUrlNew from "../BaseUrl/index"
import DeskTopView from "../Desktopview";
import RotateDeviceScreen from "../components/RotateDeviceScreen";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import { hatchback, videoSteps } from "../CameraWithOverlayVideo/data";
import ReactPlayer from "react-player";
import video from '../assets/hatchback-v3-motorway-400kbs-HQ.mov';
import SafeArea from 'react-safe-area-component'
import video_android from '../assets/hatchback-v3-1104x828-30fps.webm'
import {
  landscapeShutterToolbarStyle,
  landscapeShutterButtonStyle,
} from "../utils/landscapeShutterStyle";
import { enterImmersiveMode, exitImmersiveMode } from "../utils/immersiveMode";
import FullscreenCapturePrompt from "../components/FullscreenCapturePrompt";
import CameraZoomControls from "../components/CameraZoomControls";
import UploadErrorScreen from "../components/UploadErrorScreen";
import {
  getCameraVideoElement,
  takeZoomedPhoto,
} from "../utils/cameraZoom";
import {
  getUploadErrorMessage,
  isEvaluationImagesError,
  isInsufficientCreditMessage,
} from "../utils/uploadError";
function Camra2({ updatedata,data,index,state,view,setcamra_open ,imge_categary,img_type,add_newdata,index_of_data}) {
  // console.log("imge_categaryimge_categary ",img_type,imge_categary)
  const camera = useRef(null);
  const captureRootRef = useRef(null);
  const [image, setImage] = useState(null);
  const [cameraZoom, setCameraZoom] = useState(1);
  const { id } = useParams();
  let history = useHistory();
  const location = useLocation();
  const videoPlayer = useRef(null);
  const video_index_ref = React.useRef(0);
  const [playVideo, setplayVideo] = React.useState(false);
  const [seekdone, setseekdone] = React.useState(false);
  const [uploading, setUploading] = React.useState(false);
  const [uploadError, setUploadError] = React.useState("");
  const requestRef = React.useRef();
  const previousTimeRef = React.useRef(true);
  const arr = [].concat.apply([], Object.values(videoSteps));

  
  // const [variant_id, setVariant_id] = useState(location.state);

  // const [type, settype] = useState(location.state);

  // console.log(type, "camra page", location.state.image_id);

  const [sreen, setsreen] = useState(
    window.orientation == 90 ? "landscap" : "portrait"
  );
  const doOnOrientationChange=()=> {
    // console.log("orientation ", window.orientation);
    switch (window.orientation) {
      // case -90:
      case 90:
        setsreen("landscap");

        // console.log("landcap =========>>>>>", window.orientation);
        break;
      default:
        setsreen("portrait");
        // console.log("portrait =========>>>>", window.orientation);

        break;
    }
  }
  window.addEventListener("orientationchange", doOnOrientationChange);

  useEffect(() => {
    if (sreen !== "landscap") {
      exitImmersiveMode();
      return undefined;
    }
    enterImmersiveMode(captureRootRef.current || document.documentElement);
    return () => exitImmersiveMode();
  }, [sreen]);

  const Uploadpic = () => {
    if (uploading) return;
    enterImmersiveMode(captureRootRef.current || document.documentElement);
    setseekdone(false)
    const imageSrc = takeZoomedPhoto(
      camera,
      getCameraVideoElement(captureRootRef.current),
      cameraZoom
    );
    if (!imageSrc) {
      setseekdone(true);
      return;
    }
    PostCarimge(imageSrc)
  };
  // =========================api call section ==============
  const baseUrl =
  `${baseUrlNew.baseUrl}api/v1/evaluation_images/`;

  const handleUploadFailure = (errorOrResponse) => {
    exitImmersiveMode();
    setUploadError(getUploadErrorMessage(errorOrResponse));
  };

  const PostCarimge=(image)=> {
    setUploading(true);
    setUploadError("");
    axios
      .post(baseUrl, {
        name: imge_categary,
        type: img_type,
        image_data: image,

        evaluate_image: id,
      })
      .then((response) => {
        if (isEvaluationImagesError(response)) {
          handleUploadFailure(response);
          setseekdone(true);
          return;
        }
        add_newdata(response.data.data)
        setcamra_open(false)
      })
      .catch((error) => {
        handleUploadFailure(error);
        setseekdone(true);
      })
      .finally(() => {
        setUploading(false);
      });
  }




const donecamra=()=>{
  setcamra_open(false)
}


  if (uploadError) {
    return (
      <UploadErrorScreen
        message={uploadError}
        onRetry={
          isInsufficientCreditMessage(uploadError)
            ? undefined
            : () => setUploadError("")
        }
      />
    );
  }

  return (
    <>
    <div className="container-fluied aaa">
    <BrowserView>
          <DeskTopView />
        </BrowserView>
    <MobileView>
    {sreen == "landscap" ?(
      <div
        ref={captureRootRef}
        className="container_ pi-pictures-camera pi-pictures-camera--landscape"
        onTouchStart={() => enterImmersiveMode(captureRootRef.current || document.documentElement)}
        onClick={() => enterImmersiveMode(captureRootRef.current || document.documentElement)}
      >
        <FullscreenCapturePrompt targetRef={captureRootRef} />
        <div className="camera_main_cont">
          <div className="camera_wrapper">
          <button
            type="button"
            onClick={donecamra}
            className="done pi-capture-done"
          >
            Done
          </button>
            <Camera
              facingMode="environment"
              width="100%"
              height="100%"
              ref={camera}
            />
            <div className="video_wrapper">
              
                    <ReactPlayer
                      ref={videoPlayer}
                      playing={playVideo}
                      style={!seekdone?{"display": "None"}:{}}
                      // playing={true}/
                      playbackRate={4}
                      width="90%"
                      height="90%"
                      playsinline 
                      onReady={()=>{
                        videoPlayer.current.seekTo(arr[index_of_data].stop_at,'seconds')
                        setseekdone(true)
                      }}
                      // onProgress={(e) => videoPlayerHandler(e)}
                      // onSeek={(e) => console.log("react player onseek", e)}
                      url={window.navigator.platform=="iPhone"?video:video_android}
                      // url="https://firebasestorage.googleapis.com/v0/b/auction-85e6c.appspot.com/o/suv-v4-30fps-1104x828.webm?alt=media&token=61a99d4c-6de4-45a3-9803-49ea470efa41"
                      // url="https://firebasestorage.googleapis.com/v0/b/auction-85e6c.appspot.com/o/saloon-v3-1104x828-30fps%20(1).webm?alt=media&token=c060073c-1055-48af-83f2-3653b20be68a"
                    />
                  </div>
            <CameraZoomControls
              rootRef={captureRootRef}
              enabled={seekdone}
              zoom={cameraZoom}
              onZoomChange={setCameraZoom}
            />
          </div>
          <div className="bottom_title_bar flex_center">
                  <div> {
                   imge_categary
                  }</div>
                </div>
          <div className="tool_bar pi-capture-toolbar" style={landscapeShutterToolbarStyle}>
          {seekdone && !uploading && (
            <button
              className="round_button flex_center pi-capture-shutter"
              onClick={() => Uploadpic()}
              style={landscapeShutterButtonStyle}
            >
              <div className="round_button_ flex_center" />
            </button>
          )}
          {uploading ? (
            <div className="pi-camera-loading" aria-live="polite">
              Uploading photo…
            </div>
          ) : null}

            {/* <button onClick={videoPlayerHandler}>play/pause</button> */}
          </div>
        </div>
      </div>
    ):(
      <RotateDeviceScreen description="Hold your phone horizontally to add this photo." />
    )
    }
    </MobileView>
    </div>
    
    </>
  );
}

const mapStateToProps = (state) => ({
  car_data: state.cardata.car_pics_data,
  loading: state.cardata.loading,
});
const mapDispatchToProps = (dispatch) => {
  return {
    updatedata: (response, variant_id) =>
      dispatch(updatedata(response, variant_id)),
    add_newdata: (response, ) =>
      dispatch(add_newdata(response, )),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Camra2);
